import { handleResponseError, throwIfFailed } from 'helpers/utils'
import { API } from './endpoint'
import {
  BatchToggleSkuStockInput,
  BatchToggleSkuStockResponse,
  CreateProductInput,
  CreateProductResponse,
  DeleteProductResponse,
  GetDataSkuListResponse,
  GetInventoryByFactoryIdResponse,
  GetProductByIdResponse,
  GetProductListInput,
  GetProductListResponse,
  IncreaseProductQtyInboundInput,
  IncreaseProductQtyInboundResponse,
  UpdateProductInput,
  UpdateProductStatusInput,
  UpdateStatusProductResponse,
  ToggleSkuStockInput,
  ToggleSkuStockResponse,
  AdjustSkuStockInput,
  AdjustSkuStockResponse,
  ListSkuStockTransactionsInput,
  ListSkuStockTransactionsResponse,
  UpsertSafeStockInput,
  UpsertSafeStockResponse,
  DeleteSafeStockInput,
  DeleteSafeStockResponse,
  GetSafeStockResponse,
} from './interface'
import {
  AdjustGeneralStockInput,
  AdjustGeneralStockResponse,
  CreateGeneralStockInput,
  CreateGeneralStockResponse,
  DeleteGeneralStockResponse,
  GetGeneralStockResponse,
  ListGeneralStockTransactionsInput,
  ListGeneralStockTransactionsResponse,
  UpdateGeneralStockInput,
  UpdateGeneralStockResponse,
} from './interface/generalStock.interface'
import {
  CreateProductRecipeInput,
  GetProductRecipeResult,
  ListProductRecipeInput,
  ListProductRecipeResult,
  ProductRecipeRecord,
  UpdateProductRecipeInput,
} from './interface/productRecipe.interface'
import {
  ListStockPickerInput,
  ListStockPickerResult,
} from './interface/productStockPicker.interface'
import {
  ListProductLinkedStockInput,
  ListProductLinkedStockResult,
  SyncProductLinkedStockInput,
  SyncProductLinkedStockResult,
} from './interface/productLinkedStock.interface'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'

type ApiEnvelope<T> = { status: string; data: T }

const unwrapData = <T>(body: ApiEnvelope<T>): T => body.data

export const crateProduct = async (
  input: CreateProductInput
): Promise<CreateProductResponse> => {
  const data: AxiosResponse<CreateProductResponse> = await httpClient
    .post(API.createProduct, input)
    .catch((error) => handleResponseError(error))
  return data.data
}



export const getProductList = async (
  input: GetProductListInput
): Promise<GetProductListResponse> => {
  const data: AxiosResponse<GetProductListResponse> = await httpClient
    .post(API.getProductList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteProduct = async (
  id: string
): Promise<DeleteProductResponse> => {
  const data: AxiosResponse<DeleteProductResponse> = await httpClient
  .delete(API.deleteProduct + `${id}`)
  .catch((error) => handleResponseError(error))
  return throwIfFailed(data.data)
}


export const getProductById = async (
  productId: string
): Promise<GetProductByIdResponse> => {
  const data: AxiosResponse<GetProductByIdResponse> = await httpClient
    .get(API.getProductById + productId)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const updateProduct = async (
  input: UpdateProductInput
): Promise<CreateProductResponse> => {
  const data: AxiosResponse<CreateProductResponse> = await httpClient
    .post(API.createProduct, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateStatusProduct = async (
  input: UpdateProductStatusInput
): Promise<UpdateStatusProductResponse> => {
  const data: AxiosResponse<UpdateStatusProductResponse> = await httpClient
    .post(API.updateStatusProduct, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const increaseQtyInbound = async (
  input: IncreaseProductQtyInboundInput
): Promise<IncreaseProductQtyInboundResponse> => {
  const data: AxiosResponse<IncreaseProductQtyInboundResponse> = await httpClient
    .post(API.increaseQtyInbound, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getProductSkuList = async (): Promise<GetDataSkuListResponse> => {
  const data: AxiosResponse<GetDataSkuListResponse> = await httpClient
    .get(API.getProductSkuList)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const toggleSkuStock = async (
  input: ToggleSkuStockInput
): Promise<ToggleSkuStockResponse> => {
  const data: AxiosResponse<ToggleSkuStockResponse> = await httpClient
    .post(API.toggleSkuStock, input)
    .catch((error) => handleResponseError(error))
  return throwIfFailed(data.data)
}

export const batchToggleSkuStock = async (
  input: BatchToggleSkuStockInput
): Promise<BatchToggleSkuStockResponse> => {
  const data: AxiosResponse<BatchToggleSkuStockResponse> = await httpClient
    .post(API.batchToggleSkuStock, input)
    .catch((error) => handleResponseError(error))
  return throwIfFailed(data.data)
}

export const adjustSkuStock = async (
  input: AdjustSkuStockInput
): Promise<AdjustSkuStockResponse> => {
  const data: AxiosResponse<AdjustSkuStockResponse> = await httpClient
    .post(API.adjustSkuStock, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const listSkuStockTransactions = async (
  input: ListSkuStockTransactionsInput
): Promise<ListSkuStockTransactionsResponse> => {
  const data: AxiosResponse<ListSkuStockTransactionsResponse> = await httpClient
    .post(API.skuStockTransactions, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const upsertSafeStock = async (
  input: UpsertSafeStockInput
): Promise<UpsertSafeStockResponse> => {
  const data: AxiosResponse<UpsertSafeStockResponse> = await httpClient
    .post(API.upsertSafeStock, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getSafeStock = async (
  input: DeleteSafeStockInput
): Promise<GetSafeStockResponse> => {
  const data: AxiosResponse<GetSafeStockResponse> = await httpClient
    .post(API.getSafeStock, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteSafeStock = async (
  input: DeleteSafeStockInput
): Promise<DeleteSafeStockResponse> => {
  const data: AxiosResponse<DeleteSafeStockResponse> = await httpClient
    .post(API.deleteSafeStock, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getInventoryByFactoryId = async (
  factory_id: string,
  sort?: { sort_by: string; sort_dir: string }
): Promise<GetInventoryByFactoryIdResponse> => {
  const base = API.getInventoryByFactory(factory_id)
  const url =
    sort?.sort_by && sort?.sort_dir
      ? `${base}?sort_by=${encodeURIComponent(sort.sort_by)}&sort_dir=${encodeURIComponent(sort.sort_dir)}`
      : base
  const data: AxiosResponse<GetInventoryByFactoryIdResponse> = await httpClient
    .get(url)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createGeneralStock = async (
  input: CreateGeneralStockInput
): Promise<CreateGeneralStockResponse> => {
  const data: AxiosResponse<CreateGeneralStockResponse> = await httpClient
    .post(API.generalStockCreate, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateGeneralStock = async (
  input: UpdateGeneralStockInput
): Promise<UpdateGeneralStockResponse> => {
  const data: AxiosResponse<UpdateGeneralStockResponse> = await httpClient
    .post(API.generalStockUpdate, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteGeneralStock = async (
  id: string
): Promise<DeleteGeneralStockResponse> => {
  const data: AxiosResponse<DeleteGeneralStockResponse> = await httpClient
    .post(API.generalStockDelete, { id })
    .catch((error) => handleResponseError(error))
  return throwIfFailed(data.data)
}

export const listGeneralStockTransactions = async (
  input: ListGeneralStockTransactionsInput
): Promise<ListGeneralStockTransactionsResponse> => {
  const data: AxiosResponse<ListGeneralStockTransactionsResponse> = await httpClient
    .post(API.generalStockTransactions, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const adjustGeneralStock = async (
  input: AdjustGeneralStockInput
): Promise<AdjustGeneralStockResponse> => {
  const data: AxiosResponse<AdjustGeneralStockResponse> = await httpClient
    .post(API.generalStockAdjust, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const listGeneralStockPicker = async (
  input: ListStockPickerInput = {}
): Promise<ListStockPickerResult> => {
  const res: AxiosResponse<ApiEnvelope<ListStockPickerResult>> = await httpClient
    .post(API.generalStockList, input)
    .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}

export const listSkuStockPicker = async (
  input: ListStockPickerInput = {}
): Promise<ListStockPickerResult> => {
  const res: AxiosResponse<ApiEnvelope<ListStockPickerResult>> = await httpClient
    .post(API.skuStockList, input)
    .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}

/** ลิสต์สต็อกรวม — มาสเตอร์ + สต็อก SKU ในลิสต์เดียว */
export const listCombinedStockPicker = async (
  input: ListStockPickerInput = {}
): Promise<ListStockPickerResult> => {
  const res: AxiosResponse<ApiEnvelope<ListStockPickerResult>> = await httpClient
    .post(API.stockPickerList, input)
    .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}

export const listProductRecipes = async (
  input: ListProductRecipeInput = {}
): Promise<ListProductRecipeResult> => {
  const res: AxiosResponse<ApiEnvelope<ListProductRecipeResult>> =
    await httpClient
      .post(API.recipeList, input)
      .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}

export const getProductRecipe = async (
  id: string
): Promise<GetProductRecipeResult> => {
  const res: AxiosResponse<ApiEnvelope<GetProductRecipeResult>> =
    await httpClient
      .post(API.recipeGet, { id })
      .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}

export const createProductRecipe = async (
  input: CreateProductRecipeInput
): Promise<{ recipe: ProductRecipeRecord; items: unknown[] }> => {
  const res: AxiosResponse<
    ApiEnvelope<{ recipe: ProductRecipeRecord; items: unknown[] }>
  > = await httpClient
    .post(API.recipeCreate, input)
    .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}

export const updateProductRecipe = async (
  input: UpdateProductRecipeInput
): Promise<GetProductRecipeResult> => {
  const res: AxiosResponse<ApiEnvelope<GetProductRecipeResult>> =
    await httpClient
      .post(API.recipeUpdate, input)
      .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}

export const deleteProductRecipe = async (
  id: string
): Promise<{ success: boolean }> => {
  const res: AxiosResponse<ApiEnvelope<{ success: boolean }>> =
    await httpClient
      .post(API.recipeDelete, { id })
      .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}

export const listProductLinkedStock = async (
  input: ListProductLinkedStockInput
): Promise<ListProductLinkedStockResult> => {
  const res: AxiosResponse<ApiEnvelope<ListProductLinkedStockResult>> =
    await httpClient
      .post(API.linkedStockList, input)
      .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}

export const syncProductLinkedStock = async (
  input: SyncProductLinkedStockInput
): Promise<SyncProductLinkedStockResult> => {
  const res: AxiosResponse<ApiEnvelope<SyncProductLinkedStockResult>> =
    await httpClient
      .post(API.linkedStockSync, input)
      .catch((error) => handleResponseError(error))
  return unwrapData(res.data)
}
